module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a9021579cc12bc591ea0e2085374bee2.png";